import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Rarity } from '__generated__/globalTypes';
import { Energy } from 'atoms/icons/Energy';
import { Horizontal, Vertical } from 'atoms/layout/flex';
import { BodyM, HeadlineS, LabelS } from 'atoms/typography';
import { Chip } from 'atoms/ui/Chip';
import Dialog from 'components/dialog';
import { glossary } from 'lib/glossary';

import gift from './assets/gift.svg';
import trophy from './assets/trophy.svg';

const Wrapper = styled(Vertical)`
  padding: 0 var(--double-unit) var(--double-unit) var(--double-unit);
`;

const ImageWrapper = styled(Horizontal).attrs({ gap: 0, center: true })`
  padding: var(--unit);
  border-radius: 50%;
  border: 1px solid var(--c-nd-150);
`;

const NewChip = styled(Chip)`
  background: linear-gradient(319deg, #1510ff 16.49%, #00fff7 82.68%);
`;

type Props = {
  open: boolean;
  onClose: () => void;
};

export const EnergyBalanceHelp = ({ open, onClose }: Props) => {
  return (
    <Dialog
      open={open}
      maxWidth="xs"
      onClose={onClose}
      title={
        <NewChip>
          <LabelS bold uppercase>
            <FormattedMessage {...glossary.new} />
          </LabelS>
        </NewChip>
      }
    >
      <Wrapper gap={1.5}>
        <HeadlineS>
          <FormattedMessage
            id="EnergyBalanceHelp.title"
            defaultMessage="Energize your Classic Cards and play them in in-season competitions!"
          />
        </HeadlineS>
        <Horizontal>
          <ImageWrapper>
            <Energy size={1.5} variant={Rarity.limited} />
          </ImageWrapper>
          <BodyM>
            <FormattedMessage
              id="EnergyBalanceHelp.energy"
              defaultMessage="10 Energy per card used"
            />
          </BodyM>
        </Horizontal>
        <Horizontal>
          <ImageWrapper>
            <img height={16} width={16} src={trophy} alt="" />
          </ImageWrapper>
          <BodyM>
            <FormattedMessage
              id="EnergyBalanceHelp.competition"
              defaultMessage="1 competition entry"
            />
          </BodyM>
        </Horizontal>
        <Horizontal>
          <ImageWrapper>
            <img height={16} width={16} src={gift} alt="" />
          </ImageWrapper>
          <BodyM>
            <FormattedMessage
              id="EnergyBalanceHelp.boxes"
              defaultMessage="Win Energy in boxes"
            />
          </BodyM>
        </Horizontal>
      </Wrapper>
    </Dialog>
  );
};
